import { ServishareketdetayPage } from './../servishareketdetay/servishareketdetay';
import { ServisOdemeYapPage } from './../servis-odeme-yap/servis-odeme-yap';
import { KayitFormPage } from './../kayit-form/kayit-form';
import { CalendarComponentOptions } from 'ion2-calendar'
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ModalController, ActionSheetController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';
import { ServisHareketPage } from '../servis-hareket/servis-hareket';
import { ServisDuzenlePage } from '../servis-duzenle/servis-duzenle';
import { ServisDetayPage } from '../servis-detay/servis-detay';

@Component({
  selector: 'page-is-listesi',
  templateUrl: 'is-listesi.html',
})
export class IsListesiPage {
  aktifkullaniciyetkisi:"";
  aktifkullaniciid:number=0;
  aranan = "";
  filter = false;
  hasta = "";
  skip: number = 0;
  take: number = 50;
  isListesi = [];
  check = false;
  gizle = 1;
  telno = "";
  sunucuadresi: any;
  tarih1: any;
  tarih2: any;
  numaralar: any = {};
  Tamamla: any = {};
  Teslimet: any = {};
  smsmesaj = "";
  tarihAraligi: any;
  dateRange: {
    from: Date
    to: Date
  } = {
      from: this.tarih1,
      to: this.tarih2
    };
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsRange: CalendarComponentOptions = {
    from: new Date(2018, 1, 1),
    pickMode: 'range',
    color: "danger"
  };

  @ViewChild('sideNavUrunAra') sideNav;
  @ViewChild('sideNavUrunAra2') sideNav2;
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public ortak: Ortak,
    public actionSheetCtrl: ActionSheetController,
    public modalCtrl: ModalController,
    public navParams: NavParams) {
    this.sunucuadresi = this.ortak.storageSunucuAdresiGetir;
    this.tarih1 = this.ortak.tarih(this.ortak.storageGunTarihiGetir);
    this.tarih2 = this.tarih1;
    this.aktifkullaniciyetkisi=this.ortak.kullaniciType;
    this.aktifkullaniciid=this.ortak.storagePersonelGetir.ID;
  }

  ionViewDidLoad() {
    this.dateRange.from = this.ortak.storageGunTarihiGetir;
    this.dateRange.to = this.ortak.storageGunTarihiGetir;
    this.KayitAra2(null);
  }
  ionViewDidEnter() {
    this.KayitAra2(null);

  }
  tarihhh() {
    this.tarih1 = new Date().toISOString();
    this.tarih2 = this.tarih1;
  }
  kayitAra(e) {
    var formData = new FormData();
    formData.append("tarih1", this.ortak.tarih(this.dateRange.from));
    formData.append("tarih2", this.ortak.tarih(this.dateRange.to));
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    formData.append("yetki",this.aktifkullaniciyetkisi.toString());
    formData.append("userid",this.aktifkullaniciid.toString());
    this.bllOrtak.islem(formData, "ServisListesi", "", false).then(a => {
      var sonuc = <any>a;
      this.isListesi = sonuc.SonucObject;

    })
    this.closeNav();
  }
  KayitAra2(e) {

    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("filtre", JSON.stringify(this.gizle));
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    formData.append("yetki",this.aktifkullaniciyetkisi.toString());
    formData.append("userid",this.aktifkullaniciid.toString());
    this.bllOrtak.islem(formData, "ServiListesiFull", "", false).then(a => {
      var sonuc = <any>a;
      this.isListesi = sonuc.SonucObject;

    })
    this.closeNav2();
  }

  durums() {
    if (this.filter == false) {
      this.flashac();
    }
    else if (this.filter == true) {
      this.flashkapat();
    }

  }

  flashac() {
    this.filter = true;
    this.gizle = 0;
    this.KayitAra2(null);
  }
  flashkapat() {
    this.filter = false;
    this.gizle = 1;
    this.KayitAra2(null);
  }
  iskayitlari(e) {
    if (e.keyCode == 13) {
      this.KayitAra2(e);
    }
  }
  yenikayit() {
    this.navCtrl.push(KayitFormPage);
    // let modal = this.modalCtrl.create(KayitFormPage, "", { cssClass: "genisekran" })
    // modal.onDidDismiss(data => {
    //   this.ionViewDidLoad();
    // });
    // modal.present();
  }
  kayitduzenle(isler) {

     
      let modal = this.modalCtrl.create(ServisDuzenlePage, { vWKayit: isler }, { cssClass: "genisekran" });
      modal.onDidDismiss(data => {
        this.ionViewDidLoad();
      });
      modal.present();
    
   
  }
  odemeyap(isler) {
     
     
      let modal = this.modalCtrl.create(ServisOdemeYapPage, { vWKayit: isler }, { cssClass: "genisekran" });
      modal.onDidDismiss(data => {
        this.ionViewDidLoad();
      });
      modal.present();
    
    
  }
  hareketDetay(isler) {
    let modal = this.modalCtrl.create(ServishareketdetayPage, { vWKayit: isler }, { cssClass: "genisekran" });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  }
  servisdetay(isler) {
    let modal = this.modalCtrl.create(ServisDetayPage, { vWKayit: isler }, { cssClass: "genisekran" });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();

  }
  servisTamamenSil(isler) {
    
     
      this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz? Dikkatli Olun!!!").then(k => {
        var formData = new FormData();
        formData.append("Servis_id", isler.ID);
            this.bllOrtak.islem(formData, "ServisiTamamenSil", "", true).then(a => {
              var sonuc = <any>a;
              if(sonuc.Sonuc==1)this.ortak.showBasicAlert("Başarılı", "Servis kaydı silindi");
              this.KayitAra2(this.aranan);
        }).catch(x => {
        })
        this.KayitAra2(this.aranan);
      })
    
       
    this.KayitAra2(this.aranan);
  }
openNav() {
  let sideElement = this.sideNav.nativeElement
  sideElement.style.display = "block";
}
openNav2() {
  let sideElement = this.sideNav2.nativeElement
  sideElement.style.display = "block";
}
hareketekle(isler) {
  if (isler.DurumID == 4) {
    this.ortak.showBasicAlert("Uyarı", "Teslim Edilmiş Bir Servis Kaydına Yeni Hareket Eklenemez");
  }
  else {
    let modal = this.modalCtrl.create(ServisHareketPage, { vWKayit: isler }, { cssClass: "genisekran" });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();

  }

}
closeNav() {
  let sideElement = this.sideNav.nativeElement;
  sideElement.style.display = "none";
}
closeNav2() {
  let sideElement = this.sideNav2.nativeElement;
  sideElement.style.display = "none";
}
IslemleriAc(isler)
{
  
   this.IslemlerPersonel(isler);
  
}
Islemler(isler) {
  const actionSheet = this.actionSheetCtrl.create({
    title: 'Servis  İşlemleri',
    buttons: [
      { 
        text: 'Servisi Sil',
        icon: 'trash',
        handler: () => {
          this.servisTamamenSil(isler);
        }

      },
      {
        text: 'Hareketler',
        icon:'book',
        handler: () => {
          this.hareketDetay(isler);
        }

      },
      {
        text: 'Hareket Ekle',
        icon:'build',
        handler: () => {
          this.hareketekle(isler);
        }

      },
      {
        text: 'Odeme Yap',
        icon:'briefcase',
        handler: () => {
          this.odemeyap(isler);
        }

      },
      {
        text: 'Düzenle',
        icon:'md-create',
        handler: () => {
          this.kayitduzenle(isler);
        }
      }, {
        text: 'İptal ',
        icon:'md-close',
        role: 'cancel',
        handler: () => {

        }
      }
    ]
  });
  actionSheet.present();
}
IslemlerPersonel(isler) {
  const actionSheet = this.actionSheetCtrl.create({
    title: 'Servis  İşlemleri',
    buttons: [
   
      {
        text: 'Hareketler',
        icon:'book',
        handler: () => {
          this.hareketDetay(isler);
        }

      },
      {
        text: 'Hareket Ekle',
        icon:'build',
        handler: () => {
          this.hareketekle(isler);
        }

      },
  
     {
        text: 'İptal ',
        icon:'md-close',
        role: 'cancel',
        handler: () => {

        }
      }
    ]
  });
  actionSheet.present();
}
// ara(isler) {

//   this.numaralar=isler;


//   var formData = new FormData();
//   formData.append("gidenkayit",JSON.stringify(this.numaralar));

//   this.bllOrtak.islem(formData, "telnogetir", "", false).then(a => {
//     var sonuc = <any>a;

//     this.telno = sonuc.SonucObject;

//     if (this.telno != null && this.telno!= '') {
//       this.call.callNumber(this.telno, true)
//         .then(res => console.log('Launched dialer!', res))
//         .catch(err => console.log('Error launching dialer', err));
//     }
//     else {
//       this.ortak.showBasicAlert("UYARI", "Telefon numarası boş olamaz.");
//     }

//   })

// }
tamamla(isler)
{
  this.ortak.showConfirmAlert("Uyarı", "Kayıt Tamamlandı olarak değiştirilecektir. Devam etmek istiyor musunuz?").then(k => {
    this.tamamla = isler;
    var formData = new FormData();
    formData.append("gidenkayit", JSON.stringify(this.tamamla));

    this.bllOrtak.islem(formData, "IsiTamamla", "", false).then(a => {
      var sonuc = <any>a;
      if (sonuc.Sonuc == 1) this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");
      this.KayitAra2(null);
    })
    this.KayitAra2(null);
  })
  this.KayitAra2(null);
}
teslimodemeyap(isler)
{
  this.ortak.showConfirmAlert("Uyarı", "Ödeme Yapılacakmı?").then(k => {
    this.odemeyap(isler);

  })
  this.teslimet(isler);
}
teslimet(isler)
{
  this.ortak.showConfirmAlert("Uyarı", "Kayıt Teslim Edildi olarak değiştirilecektir. Devam etmek istiyor musunuz?").then(k => {

    this.Teslimet = isler;
    var formData = new FormData();
    formData.append("gidenkayit", JSON.stringify(this.Teslimet));

    this.bllOrtak.islem(formData, "IsiTeslimet", "", false).then(a => {
      var sonuc = <any>a;
      if (sonuc.Sonuc == 1)

        this.ortak.showBasicAlert("Başarılı", "İşlem Başarılı");

      this.ortak.showConfirmAlert("Uyarı", "Ödeme Yapılacakmı.?").then(k => {
        this.odemeyap(isler);
      })
      this.KayitAra2(null);
    })
    this.KayitAra2(null);



  })
  this.KayitAra2(null);

}




goster()
{

}
  // smsgonder(isler)
  // {
  //   let modal = this.modalCtrl.create(SmsGonderPage, { vWKayit: isler } );
  //   modal.onDidDismiss(data => {
  //     this.ionViewDidLoad();
  //   });
  //   modal.present();
  // }
 
}



// WEBPACK FOOTER //
// ./src/pages/ServisKayit/is-listesi/is-listesi.ts